import Modal from '../../../../shared/Modal'
import { ITextOption } from '../../sandbox.types'
import TextInput from '../../../../shared/Inputs/TextInput'
import { useState } from 'react'
import css from './createTextOptionModal.module.css'
import NbmgButton from '../../../../shared/NbmgButton'
import Toggle from '../../../../shared/Inputs/Toggle'

interface IProps {
  onClose: () => void
  onCreate: (option: ITextOption) => void
}

const CreateTextOptionModal = (props: IProps) => {
  const [text, setText] = useState('')
  const [right, setRight] = useState(false)

  const handleCreate = (e?) => {
    if (e) e.preventDefault()

    props.onCreate({ text, rightAnswer: right })
  }

  return (
    <Modal onClose={props.onClose}>
      <form className={css.wrapper} onSubmit={handleCreate}>
        <h2 className="form-header" style={{ textAlign: 'center' }}>
          Опция ответа
        </h2>
        <div className={css.content}>
          <TextInput value={text} name="text" onChange={setText} inscription="Текст карточки" autoFocus={true} />
          <div className="inline-flex-gap" style={{ marginTop: '1em' }}>
            <Toggle checked={right} onChange={setRight} name="right" />
            <span style={{ fontSize: '26px' }}>Правильный ответ</span>
          </div>
        </div>
        <div className={css.footer}>
          <NbmgButton withHands={true} onClick={handleCreate as any}>
            Добавить
          </NbmgButton>
        </div>
      </form>
    </Modal>
  )
}

export default CreateTextOptionModal
